// iOS / iPadOS 判定。Turnstile の自動チャレンジが iOS Safari でメインスレッド
// を長時間ブロックする現象に対する分岐に使う。
// (NativeVideoEmbed.tsx に同じ式の duplicate があるが、Turnstile 内の意味付け
//  と別物なのでここではモジュール内に閉じて持つ)
export const isIOS: boolean =
  typeof navigator !== "undefined" &&
  (/iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1));
